import { createSlice } from "@reduxjs/toolkit";

const initialOverlayState = {
    initSearch: false,
    isSearchOpen: false,
    isAllFiltersOpen: false,
    initAllFiltersOverlay: false,
    algoliaSearchTerm: null,
};
const overlaySlice = createSlice({
    name: "overlay",
    initialState: initialOverlayState,
    reducers: {
        toggleSearchOverlay(state) {
            state.isSearchOpen = !state.isSearchOpen;

            const pageBody = document.body;
            pageBody.classList.toggle("algolia-search-layer");
        },
        toggleAllFiltersOverlay(state) {
            state.isAllFiltersOpen = !state.isAllFiltersOpen;
        },
        initAllFiltersOverlay(state) {
            state.initAllFiltersOverlay = true;
        },

        resetAllFiltersOverlay(state) {
            state.initAllFiltersOverlay = false;
        },

        initSearch(state) {
            state.initSearch = true;
        },

        resetSearch(state) {
            state.initSearch = false;
        },
    },
});

export default overlaySlice;
